var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('coach-seat-layout',{attrs:{"sale":_vm.sale,"events":_vm.events},on:{"childToParent":_vm.onSeatSelectionInChild}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a29e334","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/tickets/CoachSeatSelection.vue
// module id = Mcr7
// module chunks = 0